import anime from 'animejs'

const form = () => {
  // properties
	const form = document.querySelector('.v-form__content');
	if ( !form ) return;
  const inputName = form.querySelector('input[name=full-name]');
  const inputEmail = form.querySelector('input[name=email-address]');

  // abort early if elements are not on page
  if (!inputName || !inputEmail) return;

  const fullForm = document.querySelector('.v-form__hide');
  const fullFormList = document.querySelector('.v-form__hide-list');
  const fullFormSubmitBtn = document.querySelector('.v-form__submit');
  const fullFormErrors = document.querySelector('.wpcf7-validation-errors');
  const content = document.querySelector('.v-form__content');
  const contentPadBottom = window.getComputedStyle(content).getPropertyValue('padding-bottom');
  let inputs = document.querySelectorAll('.v-form input');
  const checkboxes = document.querySelectorAll('.v-form input[type="checkbox"]');
  const textarea = document.querySelectorAll('.v-form textarea');
  inputs = [...inputs, ...textarea, ...checkboxes];
  let formInputs = [...inputs].filter(input => input.getAttribute('type') !== 'hidden');
  let isOpen = false;
  let hasErrors = false;
  let formHeight = null;

  // methods
  function hide() {

    // hide full form
    if (isOpen) {

      // re add padding bottom
      content.style.paddingBottom = contentPadBottom;

      // close form
      anime({
        targets: fullForm,
        height: [formHeight, 0],
        opacity: [1, 0],
        duration: 400,
        easing: 'easeOutSine',
        complete: () => {
          // set flags
          isOpen = false;
          fullForm.removeAttribute('style');
        }
      });
    }
  }

  function show(e) {

    console.log('e: ', e);

    if (!isOpen) {

      // open form
      fullForm.style.display = 'block';
      formHeight = fullFormList.getBoundingClientRect().height + fullFormSubmitBtn.getBoundingClientRect().height;

      anime({
        targets: fullForm,
        height: [0, formHeight],
        opacity: [0, 1],
        duration: 400,
        easing: 'easeOutSine',
        complete: () => {
          // set flags
          isOpen = true;

          // remove padding to match mockup
          content.style.paddingBottom = 0;
        }
      });
    }
  }

  function hasFocusOrInput() {

    // setTimeout in order to
    // get activeElement
    setTimeout(() => {
      const activeEl = document.activeElement;

      // check if form has value
      let formValue = [...formInputs].some(input => {

        // we only care about inputs/textareas
        if (input.tagName == 'INPUT' || input.tagName == 'TEXTAREA') {

          if (document.querySelectorAll('input:checked').length > 0) {
            return true;
          }

          // checkboxes or buttons do not affect show/hide
          if (input.getAttribute('type') != 'checkbox' && input.getAttribute('type') != 'submit') {

            // check if input has value or
            // if user is still on form
            if (input.value.length > 0 || activeEl == input) {
              return true;
            }
            return false;
          }
        }
      });

      // no value
      if (!formValue && !hasErrors) {
        // hide form
        hide();
      }
    }, 100);
  }

  // listeners
  inputName.addEventListener('focus', show);
  inputEmail.addEventListener('focus', show);

  if (fullFormErrors) {
    hasErrors = true;
    show();
  }

  // assign listener to each input
  [...formInputs].forEach(input => {
    input.addEventListener('blur', hasFocusOrInput);
  });
}

export default form